import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';
import Popper from '@di-shared/features/common/Popper';
import {ROUTE_PATHS} from '@di-shared/routes';
import {useNavigate} from 'react-router';

const HISTORY_SETTING_TOOLTIP = 'isHistorySettingTooltipOpen';

function setIsHistorySettingTooltipOpen() {
  // 최초 1회 실행
  localStorage.setItem(HISTORY_SETTING_TOOLTIP, JSON.stringify(true));
}

function getIsHistorySettingTooltipOpen() {
  const status = localStorage.getItem(HISTORY_SETTING_TOOLTIP);
  return status ? JSON.parse(status) : status;
}

export default function ({vin}: {vin: string}) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  const isHistorySettingTooltipOpen = getIsHistorySettingTooltipOpen();

  if (isHistorySettingTooltipOpen) {
    return (
      <button
        type="button"
        className="btn btn_ic"
        aria-label={t('T10005')}
        onClick={() => navigate(ROUTE_PATHS.HISTORY_SETTING.getFullPath(vin))}
      >
        <span
          className="ic ic_setting_24px"
          aria-hidden="true"
        />
      </button>
    );
  }

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      isOpen={true}
      onHide={setIsHistorySettingTooltipOpen}
      tooltip={
        <div
          role="tooltip"
          tabIndex={0}
        >
          <p
            className="tooltip_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T10023')}
          </p>
        </div>
      }
    >
      <button
        type="button"
        className="btn btn_ic"
        aria-label={t('T10005')}
        onClick={() => navigate(ROUTE_PATHS.HISTORY_SETTING.getFullPath(vin))}
      >
        <span
          className="ic ic_setting_24px"
          aria-hidden="true"
        />
      </button>
    </Popper>
  );
}
